import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../environments/environment';
import { Project } from '../../project/models/project';

@Injectable({
  providedIn: 'root'
})
export class ConfigurationDataService {

  constructor(private http: HttpClient) { }

  getProjectConfigurations = (projectId: number) => {
    return this.http.get<any[]>(`${environment.api.baseUrl}/${environment.api.endpoints.configuration.configurationList}/${projectId}/project`);
  }

  createProjectConfiguration = (projectId: number, data?: any | Project) => {
    return this.http.post(`${environment.api.baseUrl}/${environment.api.endpoints.configuration.configurationList}/${projectId}/project`, {
      ...data
    });
  }

  updateProjectConfiguration = (projectId: number, configuration: any) => {
    return this.http.put(`${environment.api.baseUrl}/${environment.api.endpoints.configuration.configurationList}/${projectId}/project`, {
      ...configuration
    });
  }

  getTrainTypes = (projectId: number) => {
    return this.http.get<any[]>(`${environment.api.baseUrl}/${environment.api.endpoints.configuration.configurationList}/${projectId}/traintypes`);
  }

  getTrainTypeConfigurations = (projectId: number, trainType: string) => {
    return this.http.get<any[]>(`${environment.api.baseUrl}/${environment.api.endpoints.configuration.configurationList}/${projectId}/traintypes/${trainType}`);
  }

  createTrainTypeConfiguration = (projectId: number, trainType: string, configuration: any) => {
    return this.http.post(`${environment.api.baseUrl}/${environment.api.endpoints.configuration.configurationList}/${projectId}/traintypes/${trainType}`, {
      ...configuration
    });
  }

  updateTrainTypeConfiguration = (projectId: number, trainType: string, configuration: any) => {
    return this.http.put(`${environment.api.baseUrl}/${environment.api.endpoints.configuration.configurationList}/${projectId}/traintypes/${trainType}/${configuration._id}`, {
      ...configuration
    });
  }
}
